<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>JWebMP Client</h1>
					<p waBody="m" waText>Client SPI contracts &mdash; AjaxCall/AjaxResponse pipeline, IPage/IPageConfigurator contracts, component model interfaces, call interceptor SPIs, and render-ordering hooks that all modules build on. Every interface serves dual purposes: compile-time contracts for type safety and runtime SPI discovery via ServiceLoader.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Guice 7</wa-tag>
						<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
						<wa-tag pill variant="neutral">Maven 4</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp:jwebmp-client</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.client</p>
					<p waBody="s" waText>Built on: JWebMP 2.0.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_79" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_80" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>COMPONENTS</div>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AjaxCall</h4>
								<p waBody="s" waColorText="quiet" waText>Request DTO carrying event data from browser to server</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.client</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AjaxResponse</h4>
								<p waBody="s" waColorText="quiet" waText>Response DTO carrying DOM updates from server to browser</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.client</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>IPageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>SPI contract for injecting CSS/JS references and configuring pages</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.client</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>IPage</h4>
								<p waBody="s" waColorText="quiet" waText>Page contract discovered via ServiceLoader for automatic route registration</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.client</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>SiteCallIntercepter</h4>
								<p waBody="s" waColorText="quiet" waText>SPI interceptor for site-wide call processing</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.client</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AjaxCallIntercepter</h4>
								<p waBody="s" waColorText="quiet" waText>SPI interceptor for AJAX call processing</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.client</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DataCallIntercepter</h4>
								<p waBody="s" waColorText="quiet" waText>SPI interceptor for data call processing</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.client</div>
							</div>
						</wa-card>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>AJAX pipeline DTOs &mdash; AjaxCall and AjaxResponse are CallScope-scoped, JSON-serializable objects</p>
					<p waBody="s" waColorText="quiet" waText>Three interceptor SPIs &mdash; SiteCallIntercepter, AjaxCallIntercepter, DataCallIntercepter with CRTP and sort-ordering</p>
					<p waBody="s" waColorText="quiet" waText>Page contracts &mdash; IPage, IPageConfigurator, IBody, IHead, IHtml define the full page lifecycle</p>
					<p waBody="s" waColorText="quiet" waText>Component model interfaces &mdash; IComponentHierarchyBase, IComponentHTMLBase, IComponentStyleBase, and 8 more</p>
					<p waBody="s" waColorText="quiet" waText>Databind hooks &mdash; IOnDataBind, IOnComponentAdded, IOnComponentHtmlRender, IAfterRenderComplete, IClientVariableWatcher</p>
					<p waBody="s" waColorText="quiet" waText>Render-ordering SPIs &mdash; RenderBeforeLinks, RenderAfterLinks, RenderBeforeScripts, RenderAfterScripts, and more</p>
					<p waBody="s" waColorText="quiet" waText>User-agent detection &mdash; UADetector parser bound as Guice singleton</p>
					<p waBody="s" waColorText="quiet" waText>Plugin metadata annotations &mdash; &#64;ComponentInformation, &#64;PluginInformation, &#64;PageConfiguration</p>
					<p waBody="s" waColorText="quiet" waText>CSS/JS reference types &mdash; CSSReference and JavascriptReference with version metadata</p>
					<p waBody="s" waColorText="quiet" waText>HTML child-constraint interfaces &mdash; GlobalChildren, FormChildren, and marker interfaces for compile-time safety</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Implement a Page Configurator</h4>
						<p waBody="s" waColorText="quiet" waText>Create a page configurator that injects CSS/JS references before rendering.</p>
						<markdown [data]="mdContent_81" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_82" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Discovered at startup to inject CSS/JS references and configure page lifecycle</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">IPage</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Page implementations discovered via ServiceLoader for route registration</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">SiteCallIntercepter</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Interceptor for processing all site calls with CRTP and sort-ordering</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">AjaxCallIntercepter</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Interceptor for processing AJAX calls with CRTP and sort-ordering</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IGuiceModule</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Registers client Guice bindings for call pipeline and interceptors</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
						<wa-tag pill variant="success">provides IGuiceModule</wa-tag>
					</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="brand">uses SiteCallIntercepter</wa-tag>
						<wa-tag pill variant="brand">uses AjaxCallIntercepter</wa-tag>
						<wa-tag pill variant="brand">uses DataCallIntercepter</wa-tag>
						<wa-tag pill variant="brand">uses IPageConfigurator</wa-tag>
						<wa-tag pill variant="brand">uses IPage</wa-tag>
						<wa-tag pill variant="brand">uses ScriptProvider</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://jwebmp.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/Client</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>